export default "__VITE_ASSET__cfb173d3__"